import { IDefaultSearchBarAction } from 'services/Search/strategies/search-bar-actions/interface'

function defaultAction({
  defaultAction: action,
}: IDefaultSearchBarAction): Function {
  return action()
}

export default defaultAction
